/**
 * Static reference data: streaming providers and genres.
 *
 * Kept in `shared` so server, catalog importers and web all agree on the ids.
 * Ids are stable slugs — never renumber or rename them once movie data
 * references them; add new entries instead.
 */
export const GENRES = [
    'action',
    'adventure',
    'animation',
    'comedy',
    'crime',
    'documentary',
    'drama',
    'family',
    'fantasy',
    'history',
    'horror',
    'music',
    'mystery',
    'romance',
    'science-fiction',
    'thriller',
    'war',
    'western',
];
export const GENRE_LABELS = {
    action: 'Action',
    adventure: 'Adventure',
    animation: 'Animation',
    comedy: 'Comedy',
    crime: 'Crime',
    documentary: 'Documentary',
    drama: 'Drama',
    family: 'Family',
    fantasy: 'Fantasy',
    history: 'History',
    horror: 'Horror',
    music: 'Music',
    mystery: 'Mystery',
    romance: 'Romance',
    'science-fiction': 'Science Fiction',
    thriller: 'Thriller',
    war: 'War',
    western: 'Western',
};
/** Countries the catalog can describe availability for. Only DE is seeded today. */
export const COUNTRIES = ['DE'];
/** Languages the catalog can hold localized display titles for. */
export const CONTENT_LOCALES = ['en', 'de'];
export function isContentLocale(value) {
    return typeof value === 'string' && CONTENT_LOCALES.includes(value);
}
export const PROVIDERS = [
    'netflix',
    'prime-video',
    'disney-plus',
    'wow',
    'apple-tv-plus',
    'paramount-plus',
    'mubi',
    'crunchyroll',
    'rtl-plus',
    'joyn',
];
export const PROVIDER_INFO = {
    netflix: { id: 'netflix', name: 'Netflix', color: '#e50914', countries: ['DE'] },
    'prime-video': { id: 'prime-video', name: 'Prime Video', color: '#00a8e1', countries: ['DE'] },
    'disney-plus': { id: 'disney-plus', name: 'Disney+', color: '#113ccf', countries: ['DE'] },
    wow: { id: 'wow', name: 'WOW', color: '#00b6ad', countries: ['DE'] },
    'apple-tv-plus': { id: 'apple-tv-plus', name: 'Apple TV+', color: '#8f8f94', countries: ['DE'] },
    'paramount-plus': {
        id: 'paramount-plus',
        name: 'Paramount+',
        color: '#0064ff',
        countries: ['DE'],
    },
    mubi: { id: 'mubi', name: 'MUBI', color: '#000000', countries: ['DE'] },
    crunchyroll: { id: 'crunchyroll', name: 'Crunchyroll', color: '#f47521', countries: ['DE'] },
    'rtl-plus': { id: 'rtl-plus', name: 'RTL+', color: '#e10714', countries: ['DE'] },
    joyn: { id: 'joyn', name: 'Joyn', color: '#fc0', countries: ['DE'] },
};
export function isGenreId(value) {
    return typeof value === 'string' && GENRES.includes(value);
}
export function isProviderId(value) {
    return typeof value === 'string' && PROVIDERS.includes(value);
}
